import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  ClickAwayListener,
  Typography,
  FormControlLabel,
  Checkbox,
  Popper,
  Grow,
  Paper,
  MenuList,
  FormGroup,
  Stack
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloseIcon from "../../../../assets/images/plus-circle-fill.svg";
import launchFormService from "../../../../services/launchForm.service";
import * as Util from "../../../../services/global.service";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
const useStyles = makeStyles({
});


const DefaultForm = (props) => {
  const { opens, close, selectViewResult } = props
  const classes = useStyles();
  const { t } = useTranslation()
  const anchorRef = React.useRef(null);
  const [list, setList] = React.useState({});
  const [mainList, setMainList] = React.useState({});
  const [checkResired, setCheckRsquired] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [reSet, setreSet] = React.useState(false);
  const [success, setSuccess] = React.useState(true);
  const [fail, setFail] = React.useState(true);
  const [pending, setPending] = React.useState(true);
  const [wait, setWait] = React.useState(true);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleCloseDialog = () => {
    close(false);
  };

  useEffect(() => {
    if (opens) {
      launchFormService.getViewResult(selectViewResult).then((rs) => {
        setList(rs?.data)
        setMainList(rs?.data)
      }).catch((error) => {

      })
    }
  }, [opens]);

  useEffect(() => {
    filterActiveSerach(mainList)
    setCheckRsquired({})
  }, [success, fail, wait, pending]);

  let sortData = (key, check1) => {
    let update = checkResired
    if (Util.formatData(list?.logs, [].length > 0)) {
      if (check1 === false && update[key] !== check1) {
        if (key === "name") {
          list.logs.sort(function (b, a) {
            if (a.employee[key].en > b.employee[key].en) {
              return -1;
            }
            if (b.employee[key].en > a.employee[key].en) {
              return 1;
            }
            return 0;
          });
        } else if (key === "code") {
          list.logs.sort(function (b, a) {
            if (a.employee[key] > b.employee[key]) {
              return -1;
            }
            if (b.employee[key] > a.employee[key]) {
              return 1;
            }
            return 0;
          });
        } else {
          list.logs.sort(function (b, a) {
            if (a[key].name > b[key].name) {
              return -1;
            }
            if (b[key].name > a[key].name) {
              return 1;
            }
            return 0;
          });
        }
        update = { [key]: false }
        setCheckRsquired(update)
        setreSet(!reSet)
      } else if (check1 === true && update[key] !== check1) {
        if (key === "name") {
          list.logs.sort(function (a, b) {
            if (a.employee[key].en > b.employee[key].en) {
              return -1;
            }
            if (b.employee[key].en > a.employee[key].en) {
              return 1;
            }
            return 0;
          });
        } else if (key === "code" || key === "name") {
          list.logs.sort(function (a, b) {
            if (a.employee[key] > b.employee[key]) {
              return -1;
            }
            if (b.employee[key] > a.employee[key]) {
              return 1;
            }
            return 0;
          });
        } else {
          list.logs.sort(function (a, b) {
            if (a[key].name > b[key].name) {
              return -1;
            }
            if (b[key].name > a[key].name) {
              return 1;
            }
            return 0;
          });
        }
        update = { [key]: true }
        setCheckRsquired(update)
        setreSet(!reSet)
      }
    }
  }

  const filterActiveSerach = (data) => {
    let result = []
    let dataFilter = JSON.parse(JSON.stringify(data))
    if (success === false && fail === false && wait === false && pending === false) {
      dataFilter.logs = []
      setList(dataFilter)
    } else if (success === true && fail === true && wait === true && pending === true) {
      setList(data)
    } else {
      if (success === true && fail === true && wait === true && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success" || rs?.status === "fail" || rs?.status === "wait");
        result = resultData
      } else if (success === true && fail === true && wait === false && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success" || rs?.status === "fail" || rs?.status === "pending");
        result = resultData
      } else if (success === true && fail === false && wait === true && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success" || rs?.status === "wait" || rs?.status === "pending");
        result = resultData
      } else if (success === false && fail === true && wait === true && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "fail" || rs?.status === "wait" || rs?.status === "pending");
        result = resultData
      } else if (success === false && fail === false && wait === true && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "wait" || rs?.status === "pending");
        result = resultData
      } else if (success === true && fail === false && wait === false && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success" || rs?.status === "pending");
        result = resultData
      } else if (success === true && fail === true && wait === false && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success" || rs?.status === "fail");
        result = resultData
      } else if (success === false && fail === true && wait === true && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "fail" || rs?.status === "wait");
        result = resultData
      } else if (success === true && fail === false && wait === true && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success" || rs?.status === "wait");
        result = resultData
      } else if (success === false && fail === true && wait === false && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "fail" || rs?.status === "pending");
        result = resultData
      } else if (success === true && fail === false && wait === false && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "success");
        result = resultData
      } else if (success === false && fail === true && wait === false && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "fail");
        result = resultData
      } else if (success === false && fail === false && wait === true && pending === false) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "wait");
        result = resultData
      } else if (success === false && fail === false && wait === false && pending === true) {
        let resultData = dataFilter.logs.filter(rs => rs?.status === "pending");
        result = resultData
      }
      dataFilter.logs = result
      setList(dataFilter)
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const EditNotActive = (data) => {
    if (data === "success") {
      setSuccess(!success)
    } else if (data === "fail") {
      setFail(!fail)
    } else if (data === "pending") {
      setPending(!pending)
    } else if (data === "wait") {
      setWait(!wait)
    } else if (data === "selectAll") {
      if (success === true && fail === true && wait === true && pending === true) {
        setSuccess(false)
        setFail(false)
        setPending(false)
        setWait(false)
      } else {
        setSuccess(true)
        setFail(true)
        setPending(true)
        setWait(true)
      }
    }
  };
  return (
    <Dialog onBackdropClick={() => { return false }} open={opens} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="xl" PaperProps={{ sx: { padding: '30px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
        Result
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0", "overflow-y": "unset" }}>
        <Box py="18px" display="flex" >
          <Typography color="#939393" minWidth="115px" maxWidth="33.33%" pr="20px" fontWeight="500" fontSize={16} lineHeight="17.6px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
            Total:<span style={{ paddingLeft: "15px", fontWeight: "400" }}>{Util.formatData(list?.information?.total, 0)}</span>
          </Typography>
          <Typography color="#939393" minWidth="115px" maxWidth="33.33%" pr="20px" fontWeight="500" fontSize={16} lineHeight="17.6px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
            Success:<span style={{ paddingLeft: "15px", fontWeight: "400" }}>{Util.formatData(list?.information?.success, 0)}</span>
          </Typography>
          <Typography color="#939393" minWidth="115px" maxWidth="33.33%" pr="20px" fontWeight="500" fontSize={16} lineHeight="17.6px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
            Fail:<span style={{ paddingLeft: "15px", fontWeight: "400", color: "#CC6058" }}>{Util.formatData(list?.information?.fail, 0)}</span>
          </Typography>
        </Box>
        <Box sx={{ border: "1px solid #CED4DA", borderRadius: "4px", p: "30px 25px" }}>
          <Box sx={{ background: "#FAFAFA", display: "flex", alignItems: "center", height: "50px", borderBottom: "1px solid #E5E5E5" }}>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "9.99%" }} pr="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" pl="15px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Code
              </Typography>
              <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("code", true)} />
                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("code", false)} />
              </Typography>
            </Box>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "26.61%" }} pr="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Name
              </Typography>
              <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
              </Typography>
            </Box>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "18.44%" }} pr="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Position
              </Typography>
              <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("position", true)} />
                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("position", false)} />
              </Typography>
            </Box>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "18.26%" }} pr="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Position Type
              </Typography>
              <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("position_type", true)} />
                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("position_type", false)} />
              </Typography>
            </Box>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "12.53%" }} pr="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Organization
              </Typography>
              <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("organization", true)} />
                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("organization", false)} />
              </Typography>
            </Box>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "14.17%", justifyContent: "center" }} pr="15px" pl="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Status
              </Typography>
              <Stack direction="row" spacing={2}>
                <div>
                  <FilterStatus
                    ref={anchorRef}
                    id="composition-button"
                    style={{ cursor: "pointer" }}
                    onClick={handleToggle}
                  />
                  <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                    style={{ "z-index": "1" }}
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === 'bottom-start' ? 'left top' : 'left bottom',
                        }}
                      >
                        <Paper sx={{ "margin-top": "5px !important" }}>
                          <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                              autoFocusItem={open}
                              id="composition-menu"
                              aria-labelledby="composition-button"
                              onKeyDown={handleListKeyDown}
                            >

                              <Box px="16px" py="6px">
                                <FormGroup>
                                  <FormControlLabel control={<Checkbox indeterminate={success === true || fail === true || wait === true || pending === true ? success === false || fail === false || wait === false || pending === false : false} onChange={e => EditNotActive("selectAll")} checked={success === true && fail === true && wait === true && pending === true} />} label={t('competency.selectAll')} />
                                  <FormControlLabel control={<Checkbox onChange={e => EditNotActive("success")} checked={success} />} label="Success" />
                                  <FormControlLabel control={<Checkbox onChange={e => EditNotActive("fail")} checked={fail} />} label="Fail" />
                                  <FormControlLabel control={<Checkbox onChange={e => EditNotActive("wait")} checked={wait} />} label="Wait" />
                                  <FormControlLabel control={<Checkbox onChange={e => EditNotActive("pending")} checked={pending} />} label="In Progress" />
                                </FormGroup>
                              </Box>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </div>
              </Stack>
            </Box>
            <Box sx={{ display: "flex", "flex-direction": "row", width: "12.53%" }} pr="15px">
              <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                Remark
              </Typography>
            </Box>
          </Box>
          <Box sx={{ height: "calc(100vh - 350px)", overflowY: "overlay", }}>
            {Util.formatData(list?.logs, []).length > 0 ? list?.logs.map((row, index) => (
              <Box sx={{ display: "flex", alignItems: "center", height: "70px", borderBottom: "1px solid #E5E5E5" }}>
                <Box pl="15px" sx={{ display: "flex", "flex-direction": "row", width: "9.99%" }} pr="15px">
                  <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                    {row?.employee?.code}
                  </Typography>
                </Box>
                <Box sx={{ width: "26.61%" }} pr="15px">
                  <Typography pb={row?.employee?.name?.th !== null && row?.employee?.name?.th !== undefined && row?.employee?.name?.th !== "" ? "0" : "5px"} fontWeight="500" fontSize={18} lineHeight="26.91px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {row?.employee?.name?.en !== undefined && row?.employee?.name?.en !== null ? Util.formatData(row?.employee?.name?.en, "") : Util.formatData(row?.employee?.fullname, "")}
                  </Typography>
                  {row?.employee?.name?.th !== null && row?.employee?.name?.th !== undefined && row?.employee?.name?.th !== "" ?
                    <Typography fontWeight="400" fontSize={16} lineHeight="20.93px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {row?.employee?.name?.th}
                    </Typography>
                    :
                    null
                  }
                </Box>
                <Box sx={{ display: "flex", "flex-direction": "row", width: "18.44%" }} pr="15px">
                  <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                    {row?.position?.code}<br />{row?.position?.name}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", "flex-direction": "row", width: "18.26%" }} pr="15px">
                  <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                    {row?.position_type?.name}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", "flex-direction": "row", width: "12.53%" }} pr="15px">
                  <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                    {row?.organization?.name}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", "flex-direction": "row", width: "14.17%", justifyContent: "center" }} pr="15px" >
                  {row?.status === "success" ?
                    <Box sx={{ background: "rgba(93, 161, 150, 0.1)", width: "100%", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                      <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#5DA196", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                        Success
                      </Typography>
                    </Box>
                    : row?.status === "fail" ?
                      <Box sx={{ background: "rgba(204, 96, 88, 0.1)", width: "100%", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                        <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#CC6058", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                          Fail
                        </Typography>
                      </Box>
                      : row?.status === "pending" ?
                        <Box sx={{ background: "rgba(239, 183, 109, 0.1)", width: "100%", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                          <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#EFB76D", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                            In Progress
                          </Typography>
                        </Box>
                        :
                        row?.status === "wait" ?
                          <Box sx={{ background: "rgba(179, 183, 184, 0.1)", width: "100%", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                            <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#B3B7B8", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                              Wait
                            </Typography>
                          </Box>
                          :
                          null
                  }
                </Box>
                <Box sx={{ display: "flex", "flex-direction": "row", width: "12.53%" }} pr="15px">
                  <Typography fontSize={14} lineHeight="23.96px" color="#404349" fontWeight="400" >
                    {row?.remark ?? ''}
                  </Typography>
                </Box>
              </Box>
            ))
              :
              <Box>
                <Box sx={{ "padding-top": "50px", "text-align": "center", }}>
                  <Nodata />
                  <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                    {t('label.noData')}
                  </Typography>
                </Box>
              </Box>
            }
          </Box>
        </Box>
      </DialogContent>
    </Dialog >
  );
};
export default DefaultForm;
